import { render } from "./ExtranetTenantAdmin.vue?vue&type=template&id=5293e290&scoped=true"
import script from "./ExtranetTenantAdmin.vue?vue&type=script&lang=js"
export * from "./ExtranetTenantAdmin.vue?vue&type=script&lang=js"

import "./ExtranetTenantAdmin.vue?vue&type=style&index=0&id=5293e290&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5293e290"]])

export default __exports__